{
  "merged": {
    "placeType": ["city", "country", "county", "state"],
    "country": [
      "United States",
      "Australia",
      "Austria",
      "Brazil",
      "Canada",
      "China",
      "Cook Islands",
      "Denmark",
      "Finland",
      "France",
      "Germany",
      "Iceland",
      "India",
      "Ireland",
      "Israel",
      "Korea",
      "Mexico",
      "Netherlands",
      "New Zealand",
      "Singapore",
      "South Africa",
      "Sweden",
      "Switzerland",
      "United Kingdom"
    ],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "regional",
      "transit-oriented"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, low-density",
      "residential, multi-family"
    ],
    "year": [
      "unknown",
      "2027",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1982",
      "1980",
      "1979",
      "1976",
      "1970",
      "1967",
      "1966",
      "1964",
      "1962",
      "1960",
      "1958",
      "1957",
      "1952",
      "1940"
    ]
  },
  "anyAdopted": {
    "placeType": ["city", "country", "county", "state"],
    "country": [
      "United States",
      "Australia",
      "Austria",
      "Brazil",
      "Canada",
      "China",
      "Denmark",
      "France",
      "Germany",
      "Iceland",
      "India",
      "Ireland",
      "Israel",
      "Korea",
      "Mexico",
      "Netherlands",
      "New Zealand",
      "Singapore",
      "South Africa",
      "Sweden",
      "Switzerland",
      "United Kingdom"
    ],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "regional",
      "transit-oriented"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, low-density",
      "residential, multi-family"
    ],
    "year": [
      "unknown",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2004",
      "2003",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1995",
      "1994",
      "1993",
      "1992",
      "1991",
      "1989",
      "1988",
      "1987",
      "1986",
      "1985",
      "1984",
      "1982",
      "1980",
      "1979",
      "1976",
      "1970",
      "1967",
      "1966",
      "1964",
      "1962",
      "1960",
      "1958",
      "1957",
      "1952",
      "1940"
    ]
  },
  "anyProposed": {
    "placeType": ["city", "country", "state"],
    "country": [
      "United States",
      "Australia",
      "Canada",
      "Cook Islands",
      "Finland"
    ],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "regional",
      "transit-oriented"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, low-density",
      "residential, multi-family"
    ],
    "year": [
      "unknown",
      "2027",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2007",
      "2003",
      "2002"
    ]
  },
  "anyRepealed": {
    "placeType": ["city", "state"],
    "country": ["United States", "China"],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "transit-oriented"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, multi-family"
    ],
    "year": ["unknown", "2026", "2025", "2023", "2022"]
  },
  "addMaxAdopted": {
    "placeType": ["city", "country", "county", "state"],
    "country": [
      "United States",
      "Australia",
      "Austria",
      "Brazil",
      "Canada",
      "China",
      "Denmark",
      "Germany",
      "Iceland",
      "India",
      "Ireland",
      "Israel",
      "Korea",
      "Mexico",
      "Netherlands",
      "Singapore",
      "Sweden",
      "Switzerland",
      "United Kingdom"
    ],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "regional",
      "transit-oriented"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, low-density",
      "residential, multi-family"
    ],
    "year": [
      "unknown",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2015",
      "2013",
      "2009",
      "2008",
      "2007",
      "2006",
      "2000",
      "1998",
      "1997",
      "1995",
      "1967",
      "1964",
      "1958"
    ]
  },
  "addMaxProposed": {
    "placeType": ["city"],
    "country": ["United States", "Canada"],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "transit-oriented"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, multi-family"
    ],
    "year": [
      "unknown",
      "2027",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2007",
      "2003"
    ]
  },
  "addMaxRepealed": {
    "placeType": ["city", "state"],
    "country": ["United States", "China"],
    "scope": ["city center / business district", "citywide"],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, multi-family"
    ],
    "year": ["unknown", "2025"]
  },
  "reduceMinAdopted": {
    "placeType": ["city", "country", "county", "state"],
    "country": [
      "United States",
      "Australia",
      "Austria",
      "Canada",
      "Denmark",
      "France",
      "Germany",
      "Iceland",
      "Ireland",
      "Israel",
      "Singapore",
      "South Africa",
      "Sweden",
      "Switzerland"
    ],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "regional",
      "transit-oriented"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, low-density",
      "residential, multi-family"
    ],
    "year": [
      "unknown",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2014",
      "2013",
      "2011",
      "2010",
      "2008",
      "2007",
      "2006",
      "2004",
      "2003",
      "2000",
      "1999",
      "1998",
      "1997",
      "1994",
      "1991",
      "1989",
      "1987",
      "1984",
      "1982",
      "1970",
      "1960",
      "1957"
    ]
  },
  "reduceMinProposed": {
    "placeType": ["city", "country"],
    "country": ["United States", "Australia", "Canada", "Cook Islands"],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "regional"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, low-density",
      "residential, multi-family"
    ],
    "year": [
      "unknown",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2017",
      "2016",
      "2015",
      "2007"
    ]
  },
  "reduceMinRepealed": {
    "placeType": ["city"],
    "country": ["United States"],
    "scope": [
      "city center / business district",
      "citywide",
      "transit-oriented"
    ],
    "landUse": ["all uses", "commercial", "other", "residential, all uses"],
    "year": ["unknown", "2026"]
  },
  "rmMinAdopted": {
    "placeType": ["city", "country", "county", "state"],
    "country": [
      "United States",
      "Australia",
      "Brazil",
      "Canada",
      "China",
      "France",
      "Germany",
      "India",
      "Ireland",
      "Israel",
      "Mexico",
      "New Zealand",
      "Singapore",
      "South Africa",
      "Sweden",
      "Switzerland",
      "United Kingdom"
    ],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "regional",
      "transit-oriented"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, low-density",
      "residential, multi-family"
    ],
    "year": [
      "unknown",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2011",
      "2010",
      "2009",
      "2008",
      "2007",
      "2006",
      "2005",
      "2002",
      "2001",
      "2000",
      "1999",
      "1998",
      "1997",
      "1995",
      "1992",
      "1989",
      "1988",
      "1986",
      "1985",
      "1984",
      "1980",
      "1979",
      "1976",
      "1970",
      "1966",
      "1962",
      "1957",
      "1952",
      "1940"
    ]
  },
  "rmMinProposed": {
    "placeType": ["city", "state"],
    "country": ["United States", "Canada", "Finland"],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special",
      "regional",
      "transit-oriented"
    ],
    "landUse": [
      "all uses",
      "commercial",
      "industrial",
      "medical",
      "other",
      "residential, all uses",
      "residential, low-density",
      "residential, multi-family"
    ],
    "year": [
      "unknown",
      "2027",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2019",
      "2018",
      "2017",
      "2016",
      "2015",
      "2014",
      "2013",
      "2012",
      "2007",
      "2002"
    ]
  },
  "rmMinRepealed": {
    "placeType": ["city"],
    "country": ["United States"],
    "scope": [
      "city center / business district",
      "citywide",
      "main street / special"
    ],
    "landUse": ["all uses", "residential, all uses"],
    "year": ["unknown", "2023", "2022"]
  },
  "benefitDistrictAdopted": {
    "placeType": ["city"],
    "country": ["United States"],
    "scope": [],
    "landUse": [],
    "year": ["2023", "2019", "1993"]
  },
  "benefitDistrictProposed": {
    "placeType": ["city"],
    "country": ["United States"],
    "scope": [],
    "landUse": [],
    "year": ["2025", "2020", "2019", "2013", "2009", "2007"]
  },
  "benefitDistrictRepealed": {
    "placeType": [],
    "country": [],
    "scope": [],
    "landUse": [],
    "year": []
  }
}
